var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0431 5.85637L21.3767 9.17746L21.5522 9.6144L22.022 9.64625L25.5926 9.88836L22.8462 12.183L22.4849 12.4849L22.5998 12.9415L23.4729 16.4123L20.4419 14.5093L20.0431 14.259L19.6443 14.5093L16.6133 16.4123L17.4864 12.9415L17.6013 12.4849L17.2399 12.183L14.4935 9.88836L18.0642 9.64625L18.534 9.6144L18.7094 9.17746L20.0431 5.85637Z",
    stroke: "#0F1011",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79504 5.85637L9.12869 9.17746L9.30416 9.6144L9.77394 9.64625L13.3446 9.88836L10.5982 12.183L10.2368 12.4849L10.3517 12.9415L11.2249 16.4123L8.19382 14.5093L7.79504 14.259L7.39626 14.5093L4.36522 16.4123L5.23836 12.9415L5.35323 12.4849L4.9919 12.183L2.24548 9.88836L5.81614 9.64625L6.28592 9.6144L6.46138 9.17746L7.79504 5.85637Z",
    stroke: "#0F1011",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9187 5.85637L15.7415 10.3955L15.917 10.8324L16.3867 10.8643L21.2669 11.1952L17.5133 14.3314L17.1519 14.6333L17.2668 15.0899L18.4602 19.8336L14.3175 17.2327L13.9187 16.9824L13.5199 17.2327L9.37725 19.8336L10.5706 15.0899L10.6855 14.6333L10.3241 14.3314L6.57047 11.1952L11.4507 10.8643L11.9205 10.8324L12.0959 10.3955L13.9187 5.85637Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9181 8.00872L15.1845 11.1625L15.36 11.5994L15.8298 11.6313L19.2205 11.8612L16.6125 14.0402L16.2511 14.3421L16.366 14.7988L17.1952 18.0946L14.3168 16.2876L13.9181 16.0372L13.5193 16.2876L10.6409 18.0946L11.4701 14.7988L11.585 14.3421L11.2236 14.0402L8.61558 11.8612L12.0063 11.6313L12.4761 11.5994L12.6516 11.1625L13.9181 8.00872Z",
    fill: "white",
    stroke: "#0F1011",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experience-icon.24dae5ee399565ab0652dba773c152d0.svg";
export { ForwardRef as ReactComponent };